import { safeStorage } from './safe-storage';

export const isIOS = (): boolean => {
  if (typeof window === 'undefined') return false;
  return /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase());
};

export const isAndroid = (): boolean => {
  if (typeof window === 'undefined') return false;
  return /android/.test(window.navigator.userAgent.toLowerCase());
};

const HEVC_NOT_SUPPORTED_KEY = 'VIDU_HEVC_NOT_SUPPORTED';

const HEVC_NATIVE_MEDIA_ERROR_CODES = new Set([
  3, // MediaError.MEDIA_ERR_DECODE
  4, // MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED
]);

export const isHevcPlaybackErrorCode = (errorCode: unknown): boolean => {
  const normalizedCode = typeof errorCode === 'string' ? Number(errorCode) : errorCode;
  if (typeof normalizedCode !== 'number' || Number.isNaN(normalizedCode)) return false;
  return HEVC_NATIVE_MEDIA_ERROR_CODES.has(normalizedCode);
};

export const isHevcSupported = (): boolean => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false;

  if (safeStorage.getItem(HEVC_NOT_SUPPORTED_KEY) === 'true') {
    return false;
  }

  const MediaSource = window.MediaSource || window.WebKitMediaSource;
  if (MediaSource?.isTypeSupported) {
    return (
      MediaSource.isTypeSupported('video/mp4;codecs="hev1.1.6.L120.90"') ||
      MediaSource.isTypeSupported('video/mp4;codecs="hev1.2.4.L120.90"') ||
      MediaSource.isTypeSupported('video/mp4;codecs="hev1.3.E.L120.90"') ||
      MediaSource.isTypeSupported('video/mp4;codecs="hev1.4.10.L120.90"')
    );
  }

  const video = document.createElement('video');
  const supportLevel = video.canPlayType('video/mp4;codecs="hvc1"');
  return supportLevel === 'probably';
};

export const markHevcNotSupported = (): void => {
  safeStorage.setItem(HEVC_NOT_SUPPORTED_KEY, 'true');
};
